import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';

@Component({
    selector: 'scaffold-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['../../rendered.component.scss', './tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TabsComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();
  init = false;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  initiated() {
    console.log('init');
    this.init = true;
  }

  scrollTo(element: HTMLElement) {
    if (this.init) {
      var headerOffset = 64;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }
}
